import { jsx as _jsx } from "react/jsx-runtime";
import Prism from "prismjs";
import React from "react";
import SimpleCodeEditor from "react-simple-code-editor";
Prism.manual = true;
const SyntaxHighlighter = (props) => {
    var _a;
    return (_jsx(SimpleCodeEditor, { value: (_a = props.code) !== null && _a !== void 0 ? _a : "", highlight: (code) => Prism.highlight(code, Prism.languages[props.language], props.language), onValueChange: (code) => props.onCodeChange(code), padding: 10, style: { backgroundColor: "#fafafa" } }));
};
export default SyntaxHighlighter;
